export const DateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'short',
  timeStyle: 'short',
});

export const DateTime = ({ d }: { d: Date | string }) => {
  return (
    <span>{DateTimeFormatter.format(d instanceof Date ? d : new Date(d))}</span>
  );
};
